import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { WorkTask } from '../models/worktask';
import { WorkTaskService } from '../services/worktask.service';

interface IState {
  workTasks: WorkTask[];
  groupId: number;
  status: string;
  columns: any;
}

export class WorkTasksPage extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      workTasks: new Array<WorkTask>(),
      groupId: 0,
      status: "",
      columns: [{
        dataField: 'id',
        text: 'ID',
        headerStyle: () => {
          return { width: '5%' };
        },
        sort: true
      },
      {
        dataField: 'taskImage',
        text: 'Slika',
        formatter: (cellContent, row) => {
          return (
            <Image src={row.taskImage} />
          );
        }
      },
      {
        dataField: 'taskName',
        text: 'Naziv zadatka',
        sort: true,
        filter: textFilter()
      }, 
      {
        dataField: 'taskOrderKey',
        text: 'Poredak (od najmanjeg broja do najvećeg)',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'edit',
        isDummyField: true,
        text: 'Uredi',
        formatter: (cellContent, row) => {
          return (
            <LinkContainer to={'/worktask/edit/' + this.state.groupId + '/' + row.id}>
              <Button className="btn-primary">
                Uredi zadatak
              </Button>
            </LinkContainer>
          );
        }
      }]
    };
  }

  componentDidMount() {

    let groupId = this.props.match.params.id ? this.props.match.params.id : 0;

    if (groupId !== 0) {

      WorkTaskService.getAllfromGroup(groupId)
        .then(
          response => {
            this.setState({
              workTasks: response,
              groupId: groupId
            });
          },
          error => {
            this.setState({
              status: error.message
            });
          }
        );
    }
  }
  
  render() {
    return (
      <div>
        <h1 className="page-title">Zadatak</h1>
        <div className="row form-group">
          <div className="col-md-12">
              <LinkContainer to={'/worktask/edit/' + this.state.groupId}>
                <Button className="btn-primary">
                  Kreiraj novi zadatak u grupi
                </Button>
              </LinkContainer>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            { this.state.status &&
              <div className={'alert alert-danger'}>{this.state.status}</div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BootstrapTable 
              striped
              hover
              keyField='id' 
              data={ this.state.workTasks } 
              columns={ this.state.columns }
              filter={ filterFactory() } 
              pagination={ paginationFactory() }/>
          </div>
        </div>
        <button
            className="button icon-left"
            onClick={this.props.history.goBack}>
            Povratak
        </button>
      </div>
    );
  }
}